/**
 * 发送事件API
 * @param {string} eventID 事件标识符
 * @param {Record<string, any>} eventVar 事件变量参数，可选
 */
export function LogEvent(eventID, eventVar) {
  if (eventVar) {
    window.gio && window.gio('track', eventID, eventVar)
  } else {
    window.gio && window.gio('track', eventID)
  }
}

/**
 * 发送页面级变量API
 * @param {Record<string, any>} pageVar 页面变量参数，可选
 */
export function LogPage(pageVar = {}) {
  window.gio && window.gio('page.set', pageVar)
}
